export default {
    GET_SINGLE_RECOVERIES: 'GET_SINGLE_RECOVERIES',
    GET_PENDING_RECOVERIES_DATA: "GET_PENDING_RECOVERIES_DATA",
    GET_REQUEST_RECOVERIES_DATA: "GET_REQUEST_RECOVERIES_DATA",
    DELETE_RECOVERY: "DELETE_RECOVERY"
}